import {
  IconButton,
} from '@chakra-ui/react';
import { Dispatch, SetStateAction, useMemo } from 'react';
import { HiBarsArrowDown,HiBarsArrowUp } from 'react-icons/hi2';

import { RequestSortType, SortOrderType } from '../hooks/useRequestSort';

enum SortDirection {
  ASC = 'created_at:asc',
  DESC = 'created_at:desc',
}

type Props = {
  sort: RequestSortType;
  setSort: Dispatch<SetStateAction<RequestSortType>>,
};

const getSortOrder = (value: SortOrderType): SortOrderType => {
  return value === SortDirection.DESC ? SortDirection.ASC : SortDirection.DESC;
};

export const RequestSort = ({ sort, setSort }: Props) => {
  const handleSortClick = () => {
    setSort((prev): RequestSortType => ({
      sort_order: getSortOrder(prev.sort_order),
    }));
  };

  const isAscending = useMemo(() => {
    return sort.sort_order === SortDirection.ASC;
  }, [sort.sort_order]);

  const colorScheme = useMemo(() => {
    return isAscending ? 'brand' : 'gray';
  }, [isAscending]);

  const sortIcon = useMemo(() => {
    return isAscending ? <HiBarsArrowUp /> : <HiBarsArrowDown />;
  }, [isAscending]);

  return (
    <IconButton
      aria-label="Open"
      size="sm"
      onClick={handleSortClick}
      colorScheme={colorScheme}
      icon={sortIcon}
    />
  );
};